<template>
  <div class="relative overflow-x-hidden">
    <component
      :is="getComponent(section.flexLayout)"
      v-for="(section, sectionIndex) in sections"
      :key="section.flexKey"
      :content="section as any"
      :id="section.id"
      :class="['h-pad transition-[padding]', verticalPadding(sectionIndex)]"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import CardsSection from '@/components/sections/repeatable/CardsSection.vue'
import CarouselSection from '@/components/sections/repeatable/CarouselSection.vue'
import CTASection from '@/components/sections/repeatable/CTASection.vue'
import FaqSection from '@/components/sections/repeatable/FaqSection.vue'
import ImageSection from '@/components/sections/repeatable/ImageSection.vue'
import LinksSection from '@/components/sections/repeatable/LinksSection.vue'
import MosaicSection from '@/components/sections/repeatable/MosaicSection.vue'
import TextImageSection from '@/components/sections/repeatable/TextImageSection.vue'
import VisitVRSection from '@/components/sections/repeatable/VisitVRSection.vue'

export default {
  name: 'RepeatableSections',
  props: {
    sections: {
      type: Array as PropType<Section[]>,
      required: true,
    },
  },
  methods: {
    getComponent(layout: Section['flexLayout']) {
      switch (layout) {
        case 'cards-section':
          return CardsSection
        case 'carousel-section':
          return CarouselSection
        case 'cta-section':
          return CTASection
        case 'image-section':
          return ImageSection
        case 'links-section':
          return LinksSection
        case 'mosaic-section':
          return MosaicSection
        case 'text-image-section':
          return TextImageSection
        case 'visit-vr-section':
          return VisitVRSection
        case 'faq-section':
          return FaqSection
        default:
          return null
      }
    },
    verticalPadding(index: number) {
      const previousSection = this.sections[index - 1]
      if (previousSection?.background === this.sections[index].background) {
        return 'pb-12.5 lg:pb-32.5'
      }

      return 'py-12.5 lg:py-32.5'
    },
  },
}
</script>
